<template>
  <v-layout d-flex wrap align-center class="ml-3 justify-space-between">
    <v-flex xs12 sm6 md2 d-flex class="pa-1">
      <v-select label="Origem" placeholder="Todos" ref="selectOrigemFiltros"
                v-model="filtros.origem" item-text="texto" item-value="valor" :menu-props="{ top: false, offsetY: true }"
                :items="converterEnumParaSelect(origemDocumento)" no-data-text="Nenhuma origem disponível">
        <span slot="prepend-item">
          <v-list-tile ripple @click="filtros.origem = null; $refs.selectOrigemFiltros.blur()">
            <v-list-tile-title>
              Todos
            </v-list-tile-title>
          </v-list-tile>
        </span>
      </v-select>
    </v-flex>
    <v-flex xs12 sm6 md3 d-flex class="pa-1">
      <v-select label="Fornecedor" placeholder="Todos" item-text="razaoSocial" item-value="id"
                v-model="filtros.fornecedorId" ref="selectFornecedorFiltros"
                no-data-text="Nenhum fornecedor disponível" :menu-props="{ top: false, offsetY: true }"
                :items="fornecedoresDisponiveis">
        <span slot="prepend-item">
          <v-list-tile ripple @click="filtros.fornecedorId = null; $refs.selectFornecedorFiltros.blur()">
            <v-list-tile-title>
              Todos
            </v-list-tile-title>
          </v-list-tile>
        </span>
      </v-select>
    </v-flex>
    <v-flex xs12 sm6 md2 d-flex class="pa-1">
      <v-select label="Tipo" placeholder="Todos" ref="selectTipoDocumentoFiltros"
                v-model="filtros.tipoDocumento" item-text="texto" item-value="valor"
                :menu-props="{ top: false, offsetY: true }"
                :items="obterItensTipoDocumento()">-->
        <span slot="prepend-item">
          <v-list-tile ripple @click="filtros.tipoDocumento = null; $refs.selectTipoDocumentoFiltros.blur()">
            <v-list-tile-title>
              Todos
            </v-list-tile-title>
          </v-list-tile>
        </span>
      </v-select>
    </v-flex>
    <v-flex xs12 sm6 md2 d-flex class="pa-1">
      <v-select label="Situação" placeholder="Todas" ref="selectsituacaoFiltros"
                v-model="filtros.situacaoDocumento" item-text="texto" item-value="valor"
                :menu-props="{ top: false, offsetY: true }"
                :items="converterEnumParaSelect(situacoesDocumentosVirtualizados)">
        <span slot="prepend-item">
          <v-list-tile ripple @click="filtros.situacaoDocumento = null; $refs.selectsituacaoFiltros.blur()">
            <v-list-tile-title>
              Todas
            </v-list-tile-title>
          </v-list-tile>
        </span>
      </v-select>
    </v-flex>
    <v-flex xs12 sm12 md3 class="d-flex flex-row">
      <az-call-to-action dark
                         :active="true"
                         :outline="false"
                         @click="aplicarFiltros">
        Pesquisar
      </az-call-to-action>
      <az-call-to-action :active="false"
                         :outline="true"
                         @click="limparFiltros">
        Limpar
      </az-call-to-action>
    </v-flex>
  </v-layout>
</template>
<script>
import {situacoesDocumentosVirtualizados, tiposDocumentoVirtualizados} from '@/commons/constants'
import AzComboEnumLicitacao from "@/commons/components/AzComboEnumLicitacao.vue";

export default {
  name: 'filtrosDocumentosCredenciamento',
  components: {AzComboEnumLicitacao},
  props: ['fornecedoresDisponiveis', 'tiposDisponiveis'],
  data(){
    return{
      situacoesDocumentosVirtualizados,
      tiposDocumentoVirtualizados,
      origemDocumento: {
        'Sistema': 'Sistema',
        'Fornecedor': 'Fornecedor',
        'Comprador': 'Comprador'
      },
      filtros:{
        origem: null,
        fornecedorId: null,
        tipoDocumento: null,
        situacaoDocumento: null
      }
    }
  },
  methods:{
    aplicarFiltros(){
      this.$emit('pesquisar', this.filtros)
    },
    limparFiltros(){
      this.filtros = {origem: null, fornecedorId: null, tipoDocumento: null, situacaoDocumento: null}
      this.aplicarFiltros();
    },
    converterEnumParaSelect(opcoes){
      return Object.entries(opcoes).map((e) => (
          {valor: e[0], texto: e[1]}
      ))
    },
    obterItensTipoDocumento(){
      if (this.tiposDisponiveis && Array.isArray(this.tiposDisponiveis)) {
        // tiposDisponiveis é um array de strings do backend (enum names)
        return this.tiposDisponiveis.map(tipo => ({
          valor: tipo,
          texto: this.tiposDocumentoVirtualizados[tipo] || tipo
        }))
      } else {
        // fallback para tiposDocumentoVirtualizados (objeto)
        return this.converterEnumParaSelect(this.tiposDocumentoVirtualizados)
      }
    }
  },
}
</script>
